import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActiveserviceService } from 'src/app/Services/ActiveUsers/activeservice.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ExoStar } from 'src/app/models/ExoStar';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { ToastrService } from 'ngx-toastr';
import { DxService } from 'src/app/Services/NewVisitNote/dx.service';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { IDxCategory, IDxIcdCodes, IDXDetails, IDxComponent } from 'src/app/models/IDXDetails';

export interface DialogData {
  textbox: any;
  type: any;
}

@Component({
  selector: 'app-diagonsis-dailog',
  templateUrl: './diagonsis-dailog.component.html',
  styleUrls: ['./diagonsis-dailog.component.css']
})
export class DiagonsisDailogComponent implements OnInit {

  DiagnosisForm: FormGroup;
  submitted = false;
  public chk: string = "";
  white: string = 'opacity: 0.0';
  blue: string = '#BAFBC1';

  ac = false;
  public type: string;
  public codes: string = "";
  public checks: string = "";
  public code: string;
  public Selectedcode: string = "";
  public NAMES = [];
  dxComponent: IDXDetails[] = [];
  dxAllIcdCodes: IDxIcdCodes[] = [];
  selectedRowIndex: number = -1;
  selecteddxComponentData: IDXDetails;
  dxCategorydata: IDxCategory[] = [];
  selectallproblemfromDbByEncId: IDxIcdCodes;
  filterDxAllIcdCodes: IDxIcdCodes[] = [];
  selctedEncIcdCode: IDxIcdCodes;
  dataSource1 = new MatTableDataSource(this.dxAllIcdCodes);
  dataSource = new MatTableDataSource(this.dxComponent);
  displayedColumnss: string[] = ['icdcode', 'icddescription',];
  text: any;
  screenType: any;
  constructor(
    public dialogRef: MatDialogRef<DiagonsisDailogComponent>, private dxService: DxService, private formBuilder: FormBuilder, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private activeserviceService: ActiveserviceService, private sharedService: SharedService) {
    this.text = data.textbox;
    this.screenType = data.type;
    if (sessionStorage.getItem("encounterid") != null || sessionStorage.getItem("encounterid") != undefined) {
      CommonComponents.encounterId = sessionStorage.getItem("encounterid");
    }
    if (sessionStorage.getItem("patientId") != null || sessionStorage.getItem("patientId") != undefined) {
      CommonComponents.patientId = parseInt(sessionStorage.getItem("patientId"));
    }
  }

  ngOnInit() {
    this.DiagnosisForm = this.formBuilder.group({
      searchTerm: [''],
      dataSource1: [],
    });
    this.loadDxFormIcddata();
    // this.DiagnosisForm.patchValue({
    //   searchTerm: this.text,
    // });
    this.DiagnosisForm.get('searchTerm').valueChanges.subscribe(
      value => {

        this.dataSource1.data = this.onIcdCodeSearcClick(value);

      });

  }

  test: string;
  fetchdata() {
    this.codes = this.text;
    this.Selectedcode = this.codes;
    var existcomments = this.text;
    var comment_array = existcomments.split(',');

    this.dxAllIcdCodes.forEach(element => {

      for (var i = 0; i < comment_array.length; i++) {

        comment_array[i] = comment_array[i].replace(/^\s*/, "").replace(/\s*$/, "");
        this.test = comment_array[i];
        if (element.icdCode === this.test) {
          const icdindex = this.dxAllIcdCodes.findIndex(x => x.icdCode === element.icdCode);
          this.dxAllIcdCodes[icdindex].background = this.blue;
          element.selected = true;
        }
      }
    });
    this.dataSource1 = new MatTableDataSource(this.dxAllIcdCodes)
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }
  onIcdCodeSearcClick(searchString: string) {
    return this.dxAllIcdCodes.filter((attr: IDxIcdCodes) => attr.icdCode.toLowerCase().indexOf(searchString.toLowerCase()) !== -1 || attr.icdCodeDescription.toLowerCase().indexOf(searchString.toLowerCase()) !== -1);
  }

  loadDxFormIcddata() {
    this.dxService.getDxIcdCodes().subscribe((data) => {
      this.dxAllIcdCodes = data.filter(i => i.isActive == true);
      this.dataSource1.data = this.dxAllIcdCodes;
      if (CommonComponents.encounterId && CommonComponents.patientId) {
        this.getDXInfo(CommonComponents.encounterId, CommonComponents.patientId);
      }
      this.dataSource1.data = this.onIcdCodeSearcClick(this.text);
      this.fetchdata();
      this.text = "";

    });

  }
  getDXInfo(encId: string, patId: number) {
    this.dxService.getDxIcdByEncId(encId, patId)
      .subscribe(
        (encDxInfo: IDXDetails[]) => {
          this.dxComponent = encDxInfo;
        },
        (err: any) => {
          console.log(err);
        });
  }
  oncellclick(element) {
    this.selectedRowIndex = element.categoryIcdId;
    if (element.selected) {
      element.selected = false;
    } else {
      element.selected = true;
    }
  }

  codewithDesc: string = '';
  onIcdCodeClick(index: number, element: IDxIcdCodes) {
    if (this.Selectedcode == null && this.Selectedcode == undefined) {
      this.Selectedcode = "";
      this.codewithDesc = "";
    }
    if (element != null && element != undefined) {
      const icdindex = this.dxAllIcdCodes.findIndex(x => x.icdCode === element.icdCode);
      var code = element.icdCode;
      var icdCodeDesc = element.icdCode + "-" + element.icdCodeDescription
      var test = this.Selectedcode.includes(code);
      if (test == false) {
        // if (this.dxAllIcdCodes[icdindex].background != this.blue) {
        this.dxAllIcdCodes[icdindex].background = this.blue;

        if (this.Selectedcode.trim() != "") {
          this.Selectedcode = this.Selectedcode.concat(", " + code);
          this.Selectedcode = this.Selectedcode.trim();
          this.Selectedcode = this.Selectedcode.replace(",,", ',');
          this.Selectedcode = this.Selectedcode.replace(", ,", ',');
          this.Selectedcode = this.Selectedcode.replace(/,\s*$/, "");
          // if (this.Selectedcode.charAt(0) == ",") {
          //   //this.Selectedcode = this.Selectedcode.substring(1);
          //   this.Selectedcode = this.Selectedcode.substring(0, this.Selectedcode.length - 2)
          // }
          if (this.Selectedcode.charAt(this.Selectedcode.length - 1) == ",") {
            this.Selectedcode = this.Selectedcode.substring(0, this.Selectedcode.length - 1);
          }
          while (this.Selectedcode.charAt(0) === ',') {
            this.Selectedcode = this.Selectedcode.substring(1);
          }

          //HX screen
          this.codewithDesc = this.codewithDesc.concat(", " + icdCodeDesc);
          this.codewithDesc = this.codewithDesc.trim();
          this.codewithDesc = this.codewithDesc.replace(",,", ',');
          this.codewithDesc = this.codewithDesc.replace(", ,", ',');
          this.codewithDesc = this.codewithDesc.replace(/,\s*$/, "");

          if (this.codewithDesc.charAt(this.codewithDesc.length - 1) == ",") {
            this.codewithDesc = this.codewithDesc.substring(0, this.codewithDesc.length - 1);
          }
          while (this.codewithDesc.charAt(0) === ',') {
            this.codewithDesc = this.codewithDesc.substring(1);
          }

          // this.DiagnosisForm.patchValue({
          //   searchTerm: this.Selectedcode,
          // });
          // this.dataSource1 = new MatTableDataSource(this.dxAllIcdCodes)
        } else {
          //  this.chk = code;
          this.Selectedcode = code;
          this.codewithDesc = icdCodeDesc;
        }
      } else {
        this.dxAllIcdCodes[icdindex].background = this.white;
        var test = this.Selectedcode.includes(code);
        this.Selectedcode = this.Selectedcode.replace(code, '');
        this.Selectedcode = this.Selectedcode.replace(",,", ',');
        this.Selectedcode = this.Selectedcode.replace(", ,", ',');
        this.Selectedcode = this.Selectedcode.replace(/,\s*$/, "");
        if (this.Selectedcode.charAt(this.Selectedcode.length - 1) == ",") {
          this.Selectedcode = this.Selectedcode.substring(0, this.Selectedcode.length - 1);
        }
        // if (this.Selectedcode.charAt(0) == ",") {
        //   // this.Selectedcode = this.Selectedcode.substring(1);
        //    this.Selectedcode = this.Selectedcode.substring(0, this.Selectedcode.length - 2)
        // }
        while (this.Selectedcode.charAt(0) === ',') {
          this.Selectedcode = this.Selectedcode.substring(1);
        }
        // this.DiagnosisForm.patchValue({
        //   searchTerm: this.Selectedcode,
        // });
        // this.dataSource1 = new MatTableDataSource(this.dxAllIcdCodes)

        // HX screen
        this.codewithDesc = this.codewithDesc.replace(icdCodeDesc, '');
        this.codewithDesc = this.codewithDesc.replace(",,", ',');
        this.codewithDesc = this.codewithDesc.replace(", ,", ',');
        this.codewithDesc = this.codewithDesc.replace(/,\s*$/, "");
        if (this.codewithDesc.charAt(this.codewithDesc.length - 1) == ",") {
          this.codewithDesc = this.codewithDesc.substring(0, this.codewithDesc.length - 1);
        }
        // if (this.Selectedcode.charAt(0) == ",") {
        //   // this.Selectedcode = this.Selectedcode.substring(1);
        //    this.Selectedcode = this.Selectedcode.substring(0, this.Selectedcode.length - 2)
        // }
        while (this.codewithDesc.charAt(0) === ',') {
          this.codewithDesc = this.codewithDesc.substring(1);
        }
        return;
      }
    }
    else {
      this.toastr.warning("Please Select diagonsis");
      return;
    }

  }
  AddClick() {
    if (this.Selectedcode)
      this.Selectedcode = this.Selectedcode.split(",").filter(i => i.trim() != "").join(",");

    if (this.Selectedcode.length > 0) {
      if (this.screenType == "HX") {
        this.dialogRef.close(this.codewithDesc);
      } else {
        this.dialogRef.close(this.Selectedcode);
      }

    }
    else {
      this.toastr.warning("Please select ICD Codes");
      this.dialogRef.close(this.Selectedcode);
    }
  }

  CancelICD() {
    this.dialogRef.close();
  }
}

